import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "account-container"
}
const _hoisted_2 = { class: "account-content" }
const _hoisted_3 = { class: "account-info-content" }
const _hoisted_4 = { class: "account-info-header" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "account-item" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "account-item" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "account-security-content" }
const _hoisted_11 = { class: "account-info-header" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "account-item" }
const _hoisted_14 = {
  key: 0,
  class: "account-abo-current-content"
}
const _hoisted_15 = { class: "account-info-header" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = {
  key: 0,
  class: "abo-info"
}
const _hoisted_18 = { class: "account-info-item" }
const _hoisted_19 = {
  key: 2,
  class: "account-info-item"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  key: 2,
  class: "special-abo-description"
}
const _hoisted_23 = { key: 3 }
const _hoisted_24 = { key: 4 }
const _hoisted_25 = { key: 5 }
const _hoisted_26 = { key: 6 }
const _hoisted_27 = { key: 7 }
const _hoisted_28 = { key: 8 }
const _hoisted_29 = {
  key: 3,
  class: "account-info-item"
}
const _hoisted_30 = {
  key: 0,
  class: "info-dense"
}
const _hoisted_31 = {
  key: 1,
  class: "info-dense"
}
const _hoisted_32 = { class: "account-abo-detail-content" }
const _hoisted_33 = { class: "account-info-item" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = {
  key: 1,
  class: "account-payments-content"
}
const _hoisted_37 = {
  key: 0,
  class: "payment-info-item"
}
const _hoisted_38 = ["title"]
const _hoisted_39 = ["innerHTML"]
const _hoisted_40 = { key: 1 }
const _hoisted_41 = {
  key: 2,
  class: "payment-info-item"
}
const _hoisted_42 = {
  key: 0,
  class: "payments-table__wrapper",
  ref: "tableWrapper"
}
const _hoisted_43 = { class: "payments-table" }
const _hoisted_44 = { class: "price" }
const _hoisted_45 = {
  key: 0,
  class: "action"
}
const _hoisted_46 = ["onClick", "title"]
const _hoisted_47 = ["innerHTML"]
const _hoisted_48 = { class: "more-settings-content" }
const _hoisted_49 = {
  key: 0,
  class: "more-settings-actions"
}
const _hoisted_50 = { key: 0 }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("a", { href: "/lizenzen" }, "Lizenzen", -1)
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = /*#__PURE__*/_createTextVNode("Datenschutz")
const _hoisted_54 = /*#__PURE__*/_createTextVNode("FAQs")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Snackbar = _resolveComponent("Snackbar")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_ctx.user)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_PageHeader, { defaultHeader: true }, {
            default: _withCtx(() => [
              _createElementVNode("h1", null, _toDisplayString(_ctx.$t('header.account')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h4", null, _toDisplayString(_ctx.$t('userData')) + ":", 1),
              _createElementVNode("button", {
                class: "ar-icon-button",
                onClick: _cache[0] || (_cache[0] = (event) =>_ctx.handleSetMode('editMode'))
              }, [
                _createElementVNode("i", {
                  class: "svgicon",
                  innerHTML: _ctx.icons.edit
                }, null, 8, _hoisted_5)
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("i", {
                innerHTML: _ctx.icons.account
              }, null, 8, _hoisted_7),
              _createElementVNode("span", null, _toDisplayString(_ctx.user.firstName) + " " + _toDisplayString(_ctx.user.lastName), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("i", {
                innerHTML: _ctx.icons.letter
              }, null, 8, _hoisted_9),
              _createElementVNode("span", null, _toDisplayString(_ctx.user.username), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("h4", null, _toDisplayString(_ctx.$t('passwordSecurity')) + ":", 1),
              _createElementVNode("button", {
                class: "ar-icon-button",
                onClick: _cache[1] || (_cache[1] = (event) =>_ctx.handleSetMode('pwChangeMode'))
              }, [
                _createElementVNode("i", {
                  class: "svgicon",
                  innerHTML: _ctx.icons.edit
                }, null, 8, _hoisted_12)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_Button, {
                text: _ctx.$t('pw_change'),
                dense: true,
                icon: _ctx.icons.password,
                iconBeforeText: true,
                onHandleClicked: _cache[2] || (_cache[2] = (event) =>_ctx.handleSetMode('pwChangeMode'))
              }, null, 8, ["text", "icon"])
            ])
          ]),
          (_ctx.user.abo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("h4", null, _toDisplayString(_ctx.$t('abo.current')) + ":", 1),
                  (_ctx.user.abo.uid != 1)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "ar-icon-button",
                        onClick: _cache[3] || (_cache[3] = (event) =>_ctx.handleSetMode('manageAbo'))
                      }, [
                        _createElementVNode("i", {
                          class: "svgicon",
                          innerHTML: _ctx.icons.edit
                        }, null, 8, _hoisted_16)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.user.abo.uid == 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.user.abo.title), 1),
                      _createVNode(_component_Button, {
                        text: _ctx.$t('button.upgradeNow'),
                        inline: true,
                        onHandleClicked: _cache[4] || (_cache[4] = (event) =>_ctx.handleSetMode('manageAbo'))
                      }, null, 8, ["text"])
                    ]))
                  : (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      text: _ctx.user.abo.title + ' ('+ _ctx.getAboPrice() +')' + (_ctx.getPriceRaw() == 0  ? (_ctx.user.abo.abodata.companyName ? ' - ' + _ctx.user.abo.abodata.companyName : '') : ''),
                      dense: true,
                      onHandleClicked: _cache[5] || (_cache[5] = (event) =>_ctx.handleSetMode('manageAbo'))
                    }, null, 8, ["text"])),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('abo.activeSince')) + ":", 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.formatDate(_ctx.user.abo.dateActivated)), 1)
                ]),
                (_ctx.user.abo.uid != 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      (_ctx.user.abo.aboSuccessor)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.$t('abo.autoChange', {aboSuccessor: _ctx.successorUserAbo?.title})), 1))
                        : _createCommentVNode("", true),
                      (_ctx.user.abo.aboSuccessor)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.formatDate(_ctx.user.abo.expirationDate)), 1))
                        : _createCommentVNode("", true),
                      (_ctx.user.abo.abodata.isSpecialOffer && _ctx.user.abo.abodata.specialOfferDescription)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(_ctx.user.abo.abodata.specialOfferDescription), 1))
                        : _createCommentVNode("", true),
                      (!_ctx.user.abo.cancelByDate && !_ctx.user.abo.aboSuccessor && !_ctx.user.abo.abodata.companyName)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_ctx.$t('abo.autoReneval')), 1))
                        : _createCommentVNode("", true),
                      (!_ctx.user.abo.cancelByDate && !_ctx.user.abo.aboSuccessor && !_ctx.user.abo.abodata.companyName)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString((_ctx.user.abo.expirationDate ? _ctx.formatDate(_ctx.user.abo.expirationDate) : '-')), 1))
                        : _createCommentVNode("", true),
                      (_ctx.user.abo.cancelByDate && !_ctx.user.abo.aboSuccessor)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_ctx.$t('abo.canceledOn')), 1))
                        : _createCommentVNode("", true),
                      (_ctx.user.abo.cancelByDate && !_ctx.user.abo.aboSuccessor)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_ctx.formatDate(_ctx.user.abo.cancelByDate)), 1))
                        : _createCommentVNode("", true),
                      (_ctx.user.abo.aboSuccessor && _ctx.user.companyCode)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(_ctx.$t('abo.joinCompanyOn', {companyName: _ctx.user.abo.abodata.companyName})), 1))
                        : _createCommentVNode("", true),
                      (_ctx.user.abo.aboSuccessor && _ctx.user.companyCode)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(_ctx.formatDate(_ctx.user.abo.expirationDate)), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.user.abo.uid != 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      (!_ctx.user.abo.cancelByDate && !_ctx.user.abo.abodata.companyName)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(_ctx.$t('abo.cancelPossibleTill')), 1))
                        : _createCommentVNode("", true),
                      (!_ctx.user.abo.cancelByDate && !_ctx.user.abo.abodata.companyName)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString((_ctx.user.abo.expirationDate ? _ctx.formatDate(_ctx.getCancellationDate(_ctx.user.abo.expirationDate)) : '-')), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('abo.newsletter')) + ":", 1),
            _createElementVNode("div", _hoisted_33, [
              (_ctx.user.newsletter)
                ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(_ctx.$t('abo.newsletter_subscribed')), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(_ctx.$t('abo.newsletter_notsubscribed')), 1)),
              _createVNode(_component_Button, {
                text: _ctx.user.newsletter ? _ctx.$t('button.unsubscribe') : _ctx.$t('button.subscribe'),
                inline: true,
                onHandleClicked: _ctx.handleChangeNewsletter
              }, null, 8, ["text", "onHandleClicked"])
            ])
          ]),
          (_ctx.payments.length >0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.$t('yourCurrentPayment')) + ":", 1),
                _createElementVNode("div", null, [
                  (_ctx.user.abo.uid != 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t('abo.lastPayment')) + ":", 1),
                        _createElementVNode("p", null, _toDisplayString(_ctx.formatDate(_ctx.getLastPayment.payment.paymentTimestamp)), 1),
                        _createElementVNode("button", {
                          class: "ar-icon-button",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleDownloadInvoice(_ctx.getLastPayment.invoice))),
                          title: _ctx.$t('button.downloadInvoice') + ' ' + _ctx.getInvoiceNumberString(_ctx.getLastPayment.invoice)
                        }, [
                          _createElementVNode("i", {
                            class: "svgicon",
                            innerHTML: _ctx.icons.downloadBill
                          }, null, 8, _hoisted_39)
                        ], 8, _hoisted_38)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t('abo.noPayment')), 1)
                      ])),
                  (_ctx.user.abo.uid != 1 && !_ctx.user.abo.cancelByDate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t('abo.nextPayment')) + ":", 1),
                        _createElementVNode("p", null, _toDisplayString(_ctx.formatDate(_ctx.user.abo.expirationDate)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.payments && _ctx.showAllPayments)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('yourPayments')) + ":", 1),
                      _createElementVNode("table", _hoisted_43, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedPayments, (entry) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: entry.payment.uid
                          }, [
                            _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(entry.payment.paymentTimestamp)), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.getPaymentStatus(entry.payment.status)), 1),
                            _createElementVNode("td", _hoisted_44, _toDisplayString(entry.payment.amount) + " " + _toDisplayString(entry.currency == "EUR" ? '€' : entry.payment.currency), 1),
                            (entry.invoice)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_45, [
                                  _createElementVNode("button", {
                                    class: "ar-icon-button",
                                    onClick: ($event: any) => (_ctx.handleDownloadInvoice(entry.invoice)),
                                    title: _ctx.$t('button.downloadInvoice')  + ' ' + _ctx.getInvoiceNumberString(entry.invoice)
                                  }, [
                                    _createElementVNode("i", {
                                      class: "svgicon",
                                      innerHTML: _ctx.icons.downloadBill
                                    }, null, 8, _hoisted_47)
                                  ], 8, _hoisted_46)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ], 512))
                  : _createCommentVNode("", true),
                (_ctx.payments.length >1)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      class: "btn-toggle-payment-list",
                      text: _ctx.showAllPayments ? _ctx.$t('button.showLess') : _ctx.$t('button.showAll'),
                      dense: true,
                      onHandleClicked: _ctx.handleToggleShowAllPayments
                    }, null, 8, ["text", "onHandleClicked"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_48, [
            _createVNode(_component_Button, {
              class: "secondary",
              text: !_ctx.showMoreSettings?_ctx.$t('button.showMoreSettings'):_ctx.$t('button.hideMoreSettings'),
              dense: true,
              onHandleClicked: _ctx.handleToggleMoreSettings
            }, null, 8, ["text", "onHandleClicked"]),
            (_ctx.showMoreSettings)
              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                  (_ctx.showLicencingLink)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_50, _hoisted_52))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", null, [
                    _createVNode(_component_router_link, { to: "privacy" }, {
                      default: _withCtx(() => [
                        _hoisted_53
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("p", null, [
                    _createVNode(_component_router_link, { to: "faqs" }, {
                      default: _withCtx(() => [
                        _hoisted_54
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_Button, {
                    text: _ctx.$t('button.deleteAccount'),
                    dense: true,
                    onHandleClicked: _ctx.handleToggleConfirmDeleteAccount
                  }, null, 8, ["text", "onHandleClicked"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(_component_Snackbar, {
          show: _ctx.snackbar.show,
          text: _ctx.snackbar.text,
          error: _ctx.snackbar.error,
          aboveBottomMenu: true
        }, null, 8, ["show", "text", "error"]),
        _createVNode(_component_Dialog, {
          show: _ctx.showConfirmDeleteAccount,
          title: _ctx.$t('dialog.confirmDeleteTitle'),
          text: ((_ctx.user.abo.uid != 1 ? _ctx.$t('dialog.confirmUserDeleteAboText01', {expirationDate: _ctx.formatDate(_ctx.user.abo.expirationDate)}) + '<br><br>' + _ctx.$t('dialog.confirmUserDeleteAboText02') + ' ' + _ctx.$t('dialog.confirmUserDeleteAboText03') + '<br><br>' : '') + _ctx.$t('dialog.confirmDeleteText')),
          buttonText: _ctx.$t('button.deleteAccount'),
          onHandleConfirm: _ctx.handleDeleteAccount,
          onHandleCancel: _ctx.handleToggleConfirmDeleteAccount
        }, null, 8, ["show", "title", "text", "buttonText", "onHandleConfirm", "onHandleCancel"])
      ]))
    : _createCommentVNode("", true)
}